'use strict';
import { appendQueryParams } from '../utils';

export default (API) => ({
    journal: {
        queryGlobal: (username = null, role = null, action = null, ipAddress = null, dateStart = null, dateStop = null) => {
            let url = `v3/journal`;
            let filters = { 'username': username, 'role': role, 'action': action, 'ipAddress': ipAddress, 'dateStart': dateStart, 'dateStop': dateStop };
            url = appendQueryParams(url, filters);
            const request = API.http.get(url);
            return API.handleError(request);
        },
        queryByEstablishment: (establishmentId, username = null, role = null, action = null, ipAddress = null, dateStart = null, dateStop = null, appointment = null) => {
            let url = `v3/establishment/` + establishmentId + `/journal`;
            let filters = { 'username': username, 'role': role, 'action': action, 'ipAddress': ipAddress, 'dateStart': dateStart, 'dateStop': dateStop, 'appointmentNumber': appointment };
            url = appendQueryParams(url, filters);
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getJournalActions: () => {
            let url = `v3/journal/actions`;
            const request = API.http.get(url);
            return API.handleError(request);
        }
    }
});
